var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchiveModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#FAFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1516 18.018L34.2766 14.268C34.1986 14.1122 34.0788 13.9812 33.9306 13.8898C33.7824 13.7983 33.6117 13.7499 33.4375 13.75H16.5625C16.3883 13.7499 16.2176 13.7983 16.0694 13.8898C15.9212 13.9812 15.8014 14.1122 15.7234 14.268L13.8484 18.018C13.7838 18.1484 13.7501 18.2919 13.75 18.4375V34.375C13.75 34.8723 13.9475 35.3492 14.2992 35.7008C14.6508 36.0525 15.1277 36.25 15.625 36.25H34.375C34.8723 36.25 35.3492 36.0525 35.7008 35.7008C36.0525 35.3492 36.25 34.8723 36.25 34.375V18.4375C36.2499 18.2919 36.2162 18.1484 36.1516 18.018ZM29.4133 26.6008C29.3262 26.6879 29.2228 26.7571 29.109 26.8043C28.9952 26.8515 28.8732 26.8757 28.75 26.8757C28.6268 26.8757 28.5048 26.8515 28.391 26.8043C28.2772 26.7571 28.1738 26.6879 28.0867 26.6008L25.9375 24.4504V31.5625C25.9375 31.8111 25.8387 32.0496 25.6629 32.2254C25.4871 32.4012 25.2486 32.5 25 32.5C24.7514 32.5 24.5129 32.4012 24.3371 32.2254C24.1613 32.0496 24.0625 31.8111 24.0625 31.5625V24.4504L21.9133 26.6008C21.8262 26.6879 21.7228 26.757 21.609 26.8041C21.4952 26.8513 21.3732 26.8755 21.25 26.8755C21.1268 26.8755 21.0048 26.8513 20.891 26.8041C20.7772 26.757 20.6738 26.6879 20.5867 26.6008C20.4996 26.5137 20.4305 26.4103 20.3834 26.2965C20.3362 26.1827 20.312 26.0607 20.312 25.9375C20.312 25.8143 20.3362 25.6923 20.3834 25.5785C20.4305 25.4647 20.4996 25.3613 20.5867 25.2742L24.3367 21.5242C24.4238 21.4371 24.5272 21.3679 24.641 21.3207C24.7548 21.2735 24.8768 21.2493 25 21.2493C25.1232 21.2493 25.2452 21.2735 25.359 21.3207C25.4728 21.3679 25.5762 21.4371 25.6633 21.5242L29.4133 25.2742C29.5004 25.3613 29.5696 25.4647 29.6168 25.5785C29.664 25.6923 29.6882 25.8143 29.6882 25.9375C29.6882 26.0607 29.664 26.1827 29.6168 26.2965C29.5696 26.4103 29.5004 26.5137 29.4133 26.6008ZM16.2039 17.5L17.1414 15.625H32.8586L33.7961 17.5H16.2039Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveModalIcon);
export default __webpack_public_path__ + "static/media/UnarchiveModalIcon.085dce80174b8c9cbfba9762ae10c57d.svg";
export { ForwardRef as ReactComponent };